import { call, put } from 'redux-saga/effects';
import moment from 'moment/moment';
import processError from '../../../utils/processError';
import { loadStatusFailed, loadStatusSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

window.serverTimeOffset = 0;

export default function* loadStatus(action) {
  try {
    const url = `${BACKEND_URL}/api/status`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK && data && data.data) {
      yield put(loadStatusSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadStatusFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadStatusFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
